import React from 'react';

import Skeleton from 'react-loading-skeleton';

import {
  OffersIncentiveDetailsContainerSkeleton,
  OffersIncentiveDetailsDescriptionSkeleton,
} from 'pages/loyalty/loyalty-offers/loyalty-offers.styled.default';

export const OffersIncentiveDetailsSkeleton = () => {
  return (
    <OffersIncentiveDetailsContainerSkeleton>
      <Skeleton width={'35rem'} height={'23rem'} />
      <Skeleton width={'4rem'} height={'1.75rem'} />
      <Skeleton width={'33rem'} height={'3rem'} />
      <Skeleton width={'30rem'} height={'1.25rem'} />
      <OffersIncentiveDetailsDescriptionSkeleton>
        <Skeleton width={'40rem'} height={'1.25rem'} />
        <Skeleton width={'40rem'} height={'1.25rem'} />
        <Skeleton width={'20rem'} height={'1.25rem'} />
      </OffersIncentiveDetailsDescriptionSkeleton>
      <Skeleton width={'15rem'} height={'2rem'} />
    </OffersIncentiveDetailsContainerSkeleton>
  );
};
